import { render, staticRenderFns } from "./DefaultRightSidebar.vue?vue&type=template&id=6816dbdc&scoped=true&lang=html&"
import script from "./DefaultRightSidebar.vue?vue&type=script&lang=js&"
export * from "./DefaultRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultRightSidebar.vue?vue&type=style&index=0&id=6816dbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6816dbdc",
  null
  
)

export default component.exports